export interface PeriodSlot {
  id: string;
  order: number;
  label: string;
  /** 24h HH:mm */
  startTime: string;
  endTime: string;
}

/** Class timetable working days: Monday–Saturday (Sunday + second Saturday are non-working; see schedules page). */
export const WEEKDAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'] as const;
export type Weekday = typeof WEEKDAYS[number];

/** One cell per period index for a weekday. */
export interface ClassTimetableGrid {
  className: string;
  /** weekday -> subject label per period (same length as periods). */
  subjects: Record<Weekday, string[]>;
}

export interface ExamEvent {
  id: string;
  title: string;
  className: string;
  date: string;
  startTime: string;
  endTime: string;
  type: 'EXAM' | 'TEST' | 'OTHER';
}
